import * as React from 'react';
import { ReactElement } from 'react';

type PageHeaderProps = {
    leftPart: ReactElement
    rightPart: ReactElement
}

function PageHeader({ leftPart, rightPart }: PageHeaderProps) {
    return <div className="page-header">
        <div className="page-header_left">{leftPart}</div>
        <div className="page-header_right">{rightPart}</div>
    </div>;
}

export default PageHeader;